import type { Messages } from "../types";

export const el = {
  "common": {
    "brand": "UN8",
    "brandTag": "Αποκλειστικό χριστιανικό dating",
    "continue": "Συνέχεια",
    "leave": "Αποχώρηση",
    "leaveForNow": "Αποχώρηση προς το παρόν",
    "yes": "Ναι",
    "no": "Όχι",
    "goBack": "Πίσω",
    "saving": "Αποθήκευση…",
    "submitting": "Υποβολή…",
    "pleaseWait": "Παρακαλώ περιμένετε…",
    "ellipsis": "…",
    "male": "Άνδρας",
    "female": "Γυναίκα",
    "phases": {
      "gate": "Πύλη",
      "verify": "Επαλήθευση",
      "setup": "Ρύθμιση",
      "profile": "Προφίλ"
    },
    "storageQuota": "Αυτό το τηλέφωνο δεν έχει χώρο για αποθηκευμένες απαντήσεις. Ελευθερώστε χώρο και δοκιμάστε ξανά.",
    "storageDisabled": "Αυτό το πρόγραμμα περιήγησης δεν θα αποθηκεύσει τις απαντήσεις σας. Απενεργοποιήστε την ιδιωτική λειτουργία ή επιτρέψτε τα δεδομένα ιστότοπου και φορτώστε ξανά.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "ελάχ. {min} χαρακτήρες"
  },
  "welcome": {
    "promise": "Στόχος μας είναι να διαγράψετε αυτή την εφαρμογή όσο το δυνατόν πιο γρήγορα.",
    "sub": "Το UN8 βοηθά σοβαρούς χριστιανούς singles να βρουν σύντροφο ζωής — και μετά να φύγουν. Επαληθευμένο. Αξίες πρώτα. Χωρίς ατελείωτο swiping.",
    "signedInAs": "Συνδεδεμένος/η ως {email}",
    "liveServer": " · live διακομιστής",
    "deviceOnly": " · μόνο αυτή η συσκευή",
    "migrateOffer": "Αυτή η συσκευή έχει ακόμα τοπικό προφίλ. Να το ανεβάσετε στον κοινό διακομιστή ώστε άλλα τηλέφωνα να σας δουν μετά τη διαμόρφωση; Τίποτα δεν ανεβαίνει μέχρι να επιλέξετε.",
    "uploadLocalProfile": "Ανέβασμα τοπικού προφίλ",
    "keepOnDevice": "Να μείνει μόνο σε αυτή τη συσκευή",
    "migrateNeedGender": "Επιλέξτε πρώτα Άνδρας ή Γυναίκα στο προφίλ σας.",
    "migrateDone": "Το κείμενο προφίλ ανέβηκε. Ξαναανεβάστε ταυτότητα, βίντεο και φωτογραφίες ώστε η διαμόρφωση να τα ελέγξει.",
    "deleteConfirm": "Οριστική διαγραφή του λογαριασμού σας, όλων των μηνυμάτων και όλων των μέσων (συμπεριλαμβανομένης ταυτότητας και βίντεο) από τον διακομιστή;",
    "accountDeleted": "Ο λογαριασμός διαγράφηκε.",
    "begin": "Έναρξη",
    "continueOnboarding": "Συνέχεια onboarding",
    "logIn": "Σύνδεση",
    "logOut": "Αποσύνδεση",
    "reviewConsole": "Κονσόλα ελέγχου",
    "matching": "Matching",
    "deleteMyAccount": "Διαγραφή λογαριασμού"
  },
  "faith": {
    "eyebrow": "Πύλη πίστης",
    "title": "Μόνο χριστιανοί",
    "text": "Το UN8 είναι κοινότητα ακόλουθων του Ιησού Χριστού, για μέλη που αναζητούν σύντροφο με προσανατολισμό στον γάμο που μοιράζεται αυτή την πίστη. Αυτή η πύλη δεν μπορεί να παρακαμφθεί.",
    "yesTitle": "Είμαι χριστιανός/ή",
    "yesBody": "Ακολουθώ τον Ιησού Χριστό και αναζητώ σύντροφο με προσανατολισμό στον γάμο που μοιράζεται αυτή την πίστη.",
    "noTitle": "Δεν είμαι χριστιανός/ή",
    "noBody": "Το UN8 δεν είναι το σωστό μέρος για μένα — και αυτό είναι εντάξει.",
    "respectTitle": "Με σεβασμό",
    "respectBody": "Το UN8 χτίστηκε για μία κοινότητα, και προτιμούμε να είμαστε ειλικρινείς παρά να χάνουμε τον χρόνο σας. Χρησιμοποιήστε Αποχώρηση παρακάτω ή Πίσω, αν αυτό δεν είναι το σπίτι σας.",
    "sharedTitle": "Κοινό θεμέλιο",
    "sharedBody": "Η πίστη εδώ δεν είναι ετικέτα. Είναι το έδαφος πάνω στο οποίο συναντιέστε.",
    "hintNotChristian": "Το UN8 είναι για ακόλουθους του Ιησού Χριστού. Πατήστε Αποχώρηση παρακάτω ή επιλέξτε την χριστιανική επιλογή αν αυτό είστε εσείς.",
    "hintUnset": "Πατήστε «Είμαι χριστιανός/ή» για συνέχεια, ή Αποχώρηση / Πίσω αν αυτό δεν είναι το σπίτι σας."
  },
  "rules": {
    "eyebrow": "Διαθήκη κοινότητας",
    "title": "Πώς συμπεριφερόμαστε ο ένας στον άλλον",
    "text": "Επιβεβαιώστε κάθε κανόνα. Και οι τρεις απαιτούνται. Παραβάσεις οδηγούν σε οριστική αφαίρεση. Ψεύτικα προφίλ απαγορεύονται για πάντα.",
    "agreeContinue": "Συμφωνώ — συνέχεια",
    "respectful": {
      "title": "Να είστε σεβαστικοί",
      "description": "Μιλήστε και ενεργήστε με αξιοπρέπεια. Κάθε άνθρωπος εδώ είναι φτιαγμένος κατ’ εικόνα Θεού."
    },
    "noSexualContent": {
      "title": "Χωρίς σεξουαλικό περιεχόμενο",
      "description": "Χωρίς ρητές φωτογραφίες, μηνύματα ή αιτήματα. Η αγνότητα δεν είναι προαιρετική εδώ."
    },
    "noDominance": {
      "title": "Μην κυριαρχείτε ούτε ελέγχετε",
      "description": "Χωρίς εξαναγκασμό, χειραγώγηση ή πίεση. Η αγάπη δεν ελέγχει."
    },
    "hint": "Τσεκάρετε και τις τρεις υποσχέσεις πριν συνεχίσετε."
  },
  "intent": {
    "eyebrow": "",
    "title": "Τι ψάχνεις;",
    "text": "",
    "marriage": {
      "label": "Έναν σύντροφο ζωής",
      "description": ""
    },
    "discernment": {
      "label": "Σοβαρή διάκριση",
      "description": ""
    },
    "notCasual": {
      "label": "Τίποτα επιπόλαιο",
      "description": ""
    },
    "hint": "Διάλεξε ένα."
  },
  "account": {
    "eyebrow": "Λογαριασμός",
    "title": "Δημιουργήστε την πρόσβασή σας",
    "text": "Το handle σας δημιουργεί σταθερό user id. Αίτηση, επαλήθευση, likes και matches δεσμεύονται σε αυτό το id. Δεν αποστέλλεται email.",
    "recoveryTitle": "Αποθηκεύστε τον κωδικό ανάκτησης",
    "recoveryText": "Εμφανίζεται μία φορά. Χωρίς αυτόν, χαμένο passphrase δεν μπορεί να επαναφερθεί σε αυτό το κλειστό τεστ.",
    "savedContinue": "Το αποθήκευσα — συνέχεια",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com ή σύντομο handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Τουλάχιστον 8 χαρακτήρες",
    "signedInTitle": "Συνδεδεμένος/η",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Πρότυπο εμπιστοσύνης",
    "trustBody": "Κανένα προφίλ δεν είναι ορατό μέχρι να ολοκληρωθεί η επαλήθευση ταυτότητας και να σας εγκρίνει η διαμόρφωση.",
    "continueToVerification": "Συνέχεια στην επαλήθευση",
    "hintEmail": "Πληκτρολογήστε διεύθυνση email που περιλαμβάνει @.",
    "hintPassword": "Επιλέξτε κωδικό τουλάχιστον 8 χαρακτήρων."
  },
  "verify": {
    "intro": {
      "eyebrow": "Επαλήθευση",
      "title": "Η εμπιστοσύνη είναι η πύλη",
      "text": "Ανεβάστε κυβερνητική ταυτότητα, βίντεο επιβεβαίωσης και {min}–{max} πραγματικές φωτογραφίες. Όλα μπαίνουν σε ουρά ελέγχου πριν εμφανιστεί το προφίλ σας.",
      "whyTitle": "Γιατί επαληθεύουμε",
      "whyBody": "Το catfishing και οι μισές αλήθειες δεν έχουν θέση εδώ. Ψεύτικα προφίλ απαγορεύονται οριστικά. Τα μέσα αποθηκεύονται με κατάσταση pending_review μέχρι την έγκριση.",
      "start": "Έναρξη επαλήθευσης"
    },
    "steps": {
      "id": {
        "title": "Κυβερνητική ταυτότητα",
        "description": "Διαβατήριο ή εθνική ταυτότητα — κάμερα ή ανέβασμα αρχείου."
      },
      "video": {
        "title": "Βίντεο επιβεβαίωσης",
        "description": "Σύντομη εγγραφή που αποδεικνύει ότι είστε παρόντες."
      },
      "photos": {
        "title": "Πραγματικές φωτογραφίες",
        "description": "Επτά έως δέκα καθαρές φωτογραφίες του εαυτού σας."
      },
      "review": {
        "title": "Έλεγχος ακεραιότητας",
        "description": "Τα ανεβάσματα μένουν pending_review μέχρι να επιβεβαιώσει το προσωπικό."
      }
    },
    "id": {
      "eyebrow": "Βήμα 1 από 4",
      "title": "Κυβερνητική ταυτότητα",
      "text": "Τραβήξτε ή ανεβάστε το διαβατήριο ή την εθνική ταυτότητά σας. Τίποτα δεν δημοσιεύεται δημόσια — η κατάσταση μένει pending_review μέχρι να επιβεβαιώσει το προσωπικό.",
      "savedTitle": "Η ταυτότητα αποθηκεύτηκε",
      "savedBody": "Ακολουθεί σύντομο βίντεο επιβεβαίωσης του προσώπου σας, μετά 7 έως 10 πραγματικές φωτογραφίες. Η Συνέχεια ξεκλειδώνει όταν αυτή η ταυτότητα δείχνει αποθηκευμένη.",
      "hint": "Τραβήξτε ή ανεβάστε φωτογραφία της κυβερνητικής ταυτότητάς σας και περιμένετε μέχρι να γράφει αποθηκευμένη."
    },
    "video": {
      "eyebrow": "Βήμα 2 από 4",
      "title": "Βίντεο επιβεβαίωσης",
      "text": "Ηχογραφήστε σύντομο κλιπ ή ανεβάστε ένα. Κοιτάξτε την κάμερα. Μιλήστε καθαρά. Αυτό αποδεικνύει ότι είστε παρόντες — όχι συλλεγμένη γκαλερί.",
      "hint": "Ηχογραφήστε σύντομο βίντεο επιβεβαίωσης και περιμένετε μέχρι να γράφει αποθηκευμένο."
    },
    "photos": {
      "eyebrow": "Βήμα 3 από 4",
      "title": "Πραγματικές φωτογραφίες",
      "text": "Προσθέστε {min}–10 πρόσφατες φωτογραφίες του εαυτού σας. Χρησιμοποιήστε την κάμερα ή τη βιβλιοθήκη. Πατήστε × για αφαίρεση.",
      "continueToReview": "Συνέχεια στον έλεγχο",
      "hint": "Προσθέστε {min} έως 10 καθαρές φωτογραφίες του εαυτού σας. Η Συνέχεια ξεκλειδώνει όταν αποθηκευτούν."
    },
    "review": {
      "eyebrow": "Βήμα 4 από 4",
      "title": "Έλεγχος ακεραιότητας",
      "text": "Τα μέσα είναι σε ουρά ως pending_review{underUser}. Matches και likes θα χρησιμοποιούν το ίδιο id.",
      "underUser": " κάτω από χρήστη {userId}",
      "governmentId": "Κυβερνητική ταυτότητα",
      "confirmationVideo": "Βίντεο επιβεβαίωσης",
      "photos": "Φωτογραφίες",
      "missing": "Λείπει",
      "filesReady": "{count} αρχεία έτοιμα",
      "submittedTitle": "Υποβλήθηκε για έλεγχο",
      "submittedText": "Το application id ισούται με το auth user id ώστε approve → pool και αμοιβαία likes να μένουν ευθυγραμμισμένα.",
      "submitContinue": "Υποβολή & συνέχεια"
    }
  },
  "setup": {
    "eyebrow": "Ρύθμιση λογαριασμού",
    "title": "Πείτε την αλήθεια για τον εαυτό σας",
    "text": "Αυτές οι απαντήσεις διαμορφώνουν το matching και εμφανίζονται στον έλεγχο. Οι ήπια ψέματα χάνουν τον χρόνο όλων — και τον δικό σας.",
    "beginSetup": "Έναρξη ρύθμισης",
    "pillars": {
      "faith": {
        "name": "Πίστη",
        "text": "Γιατί ακολουθείτε τον Χριστό."
      },
      "character": {
        "name": "Χαρακτήρας",
        "text": "Αφοσίωση, ειλικρίνεια, πάθος, δέσμευση — βαθμολογία 1–10."
      },
      "story": {
        "name": "Ιστορία",
        "text": "Ποιοι είστε και τι αναζητάτε."
      },
      "life": {
        "name": "Ζωή",
        "text": "Χόμπι, διάβασμα και επάγγελμα."
      }
    },
    "whyChristian": {
      "eyebrow": "Πίστη",
      "title": "Γιατί είστε χριστιανός/ή;",
      "text": "Σύντομη, ειλικρινής απάντηση. Όχι κήρυγμα — ένας λόγος που είναι δικός σας.",
      "label": "Η απάντησή σας",
      "placeholder": "π.χ. Συνάντησα τον Χριστό σε μια περίοδο απώλειας και Τον ακολουθώ από τότε…",
      "hint": "Γράψτε τουλάχιστον {min} χαρακτήρες για το γιατί ακολουθείτε τον Ιησού."
    }
  },
  "scales": {
    "eyebrow": "Κλίμακες χαρακτήρα",
    "title": "Αξιολογήστε τον εαυτό σας ειλικρινά",
    "text": "Αφοσίωση, ειλικρίνεια, πάθος, δέσμευση — καθένα από 1 έως 10. Η υπερβολή αριθμών οδηγεί μόνο σε λάθος match αργότερα. Πρέπει να ορίσετε κάθε κλίμακα για συνέχεια.",
    "loyalty": {
      "label": "Επίπεδο αφοσίωσης",
      "hint": "Να είστε ειλικρινείς — πόσο πιστά στέκεστε δίπλα σε όσους αγαπάτε;"
    },
    "honesty": {
      "label": "Επίπεδο ειλικρίνειας",
      "hint": "Πόσο σταθερά λέτε όλη την αλήθεια;"
    },
    "passion": {
      "label": "Πόσο παθιασμένοι είστε;",
      "hint": "Πεποίθηση και βάθος — όχι παράσταση."
    },
    "commitment": {
      "label": "Επίπεδο δέσμευσης",
      "hint": "Πόσο έτοιμοι είστε να χτίσετε κάτι που διαρκεί;"
    },
    "hint": "Μετακινήστε κάθε ρυθμιστή ώστε να εμφανίζεται αριθμός — κανένας να μην μείνει παύλα."
  },
  "about": {
    "eyebrow": "Για εσάς",
    "title": "Περιγράψτε τον εαυτό σας σε λίγες προτάσεις",
    "text": "Ποιοι είστε όταν κανείς δεν παίζει ρόλο. Ιδιοσυγκρασία, ρυθμός, τι μετράει καθημερινά.",
    "label": "Για εσάς",
    "placeholder": "Ήσυχα πρωινά, σοβαρός/ή για την οικογένεια, γελάω εύκολα, προτιμώ βάθος αντί θόρυβο…",
    "hint": "Γράψτε τουλάχιστον {min} χαρακτήρες για τον εαυτό σας."
  },
  "looking": {
    "eyebrow": "Σύντροφος",
    "title": "Τι αναζητάτε;",
    "text": "Κύρια χαρακτηριστικά χαρακτήρα που επιθυμείτε σε πιθανό σύντροφο — όχι λίστα αγορών για εμφάνιση.",
    "label": "Επιθυμητά χαρακτηριστικά χαρακτήρα",
    "placeholder": "π.χ. Σταθερή πίστη, συναισθηματική ωριμότητα, καλοσύνη υπό πίεση…",
    "hint": "Γράψτε τουλάχιστον {min} χαρακτήρες για τον σύντροφο που ελπίζετε."
  },
  "loveReady": {
    "eyebrow": "Κατώφλι",
    "title": "Είστε έτοιμοι να γνωρίσετε τον έρωτα της ζωής σας;",
    "text": "Το UN8 υπάρχει ώστε σοβαροί singles να βρουν σύντροφο — και μετά να διαγράψουν την εφαρμογή. Μόνο το «Ναι» ξεκλειδώνει τη συνέχεια.",
    "yesTitle": "Ναι — είμαι έτοιμος/η",
    "yesBody": "Είμαι εδώ να γνωρίσω τον άνθρωπό μου με σαφήνεια και θάρρος.",
    "noTitle": "Όχι ακόμα",
    "noBody": "Αν απλώς περιηγείστε, αυτή η κοινότητα δεν είναι η σωστή.",
    "comeBackTitle": "Επιστρέψτε όταν είστε έτοιμοι",
    "comeBackBody": "Το UN8 είναι για ανθρώπους έτοιμους να γνωρίσουν — όχι να συλλέγουν επιλογές. Χρησιμοποιήστε Αποχώρηση παρακάτω αν θέλετε να σταματήσετε προς το παρόν. Οι απαντήσεις σας αποθηκεύονται σε αυτό το τηλέφωνο.",
    "hintNo": "Μόνο το «Ναι» συνεχίζει. Αν δεν είστε έτοιμοι, πατήστε Αποχώρηση προς το παρόν — οι απαντήσεις μένουν σε αυτό το τηλέφωνο.",
    "hintUnset": "Πατήστε Ναι αν είστε έτοιμοι να γνωρίσετε κάποιον για γάμο."
  },
  "lifestyle": {
    "eyebrow": "Τρόπος ζωής",
    "title": "Πώς ζείτε καθημερινά",
    "text": "Αθλήματα, χόμπι, διάβασμα και επάγγελμα — πρακτικά σήματα πραγματικής συμβατότητας.",
    "hobbies": "Τρέχοντα αθλήματα ή χόμπι",
    "hobbiesPlaceholder": "Τι κάνετε ενεργά — όχι τι κάνατε κάποτε.",
    "reading": "Διαβάζετε;",
    "readingHint": "1 = σχεδόν ποτέ · 10 = καθημερινά, βαθύ διάβασμα",
    "profession": "Επάγγελμα / τομέας",
    "professionPlaceholder": "π.χ. Νοσηλευτική · Λογισμικό · Εκπαίδευση · Τεχνικά επαγγέλματα",
    "hintHobbies": "Ονομάστε τουλάχιστον ένα άθλημα ή χόμπι που πραγματικά κάνετε.",
    "hintReading": "Μετακινήστε το «Διαβάζετε;» ώστε να εμφανίζεται αριθμός από 1 έως 10.",
    "hintProfession": "Πληκτρολογήστε τη δουλειά σας, έστω μια σύντομη λέξη."
  },
  "faithDepth": {
    "eyebrow": "Matching · Πίστη",
    "title": "Πόσο κεντρική είναι η πίστη σας;",
    "text": "Υπηρεσία στον Θεό — πόσο σημαντική στη ζωή σας; Απαντήστε ειλικρινά. Το matching το χρησιμοποιεί για βάθος, όχι για παράσταση.",
    "serving": "Υπηρεσία στον Θεό — σημασία",
    "servingHint": "10% … 100%. Σύρετε σε βήματα των 10.",
    "keepsCommandments": "Τηρείτε τις εντολές;",
    "grewUpInChurch": "Μεγαλώσατε στην εκκλησία;",
    "churchAttendance": "Παρουσία στην εκκλησία",
    "frequent": {
      "label": "Συχνά",
      "hint": "Τακτική συνάθροιση με το σώμα του Χριστού."
    },
    "seldom": {
      "label": "Σπάνια",
      "hint": "Περιστασιακά, όχι εβδομαδιαίος ρυθμός."
    },
    "never": {
      "label": "Ποτέ",
      "hint": "Δεν παρακολουθείτε αυτή τη στιγμή."
    },
    "spreadsGospel": "Διαδίδετε το ευαγγέλιο;",
    "hasIdols": "Έχετε είδωλα;",
    "hintServing": "Σύρετε πόσο σημαντική είναι η υπηρεσία στον Θεό στη ζωή σας.",
    "hintCommandments": "Απαντήστε αν τηρείτε τις εντολές — Ναι ή Όχι.",
    "hintGrewUp": "Απαντήστε αν μεγαλώσατε στην εκκλησία — Ναι ή Όχι.",
    "hintAttendance": "Επιλέξτε πόσο συχνά πηγαίνετε στην εκκλησία.",
    "hintGospel": "Απαντήστε αν μοιράζεστε το ευαγγέλιο — Ναι ή Όχι.",
    "hintIdols": "Απαντήστε αν έχετε είδωλα — Ναι ή Όχι."
  },
  "character": {
    "eyebrow": "Matching · Χαρακτήρας",
    "title": "Ποιοι είστε στο σπίτι",
    "text": "Χαρακτήρας για μνηστεία — ειρήνη, τρόποι, ειλικρίνεια. Η υπερβολή απαντήσεων οδηγεί μόνο σε λάθος match αργότερα.",
    "peacemaker": "Είστε ειρηνοποιός;",
    "homebuilder": "Είστε οικοδόμος σπιτιού;",
    "humorous": "Έχετε χιούμορ;",
    "caring": "Φροντιστικοί και τρυφεροί;",
    "peacefulHome": "Θέλετε ειρηνικό σπίτι — χωρίς καβγάδες;",
    "manners": "Καλοί τρόποι;",
    "honestyRating": "Βαθμολογία ειλικρίνειας σε αυτό το ερωτηματολόγιο",
    "honestyHint": "1–10 — πόσο ειλικρινά απαντάτε;",
    "hintPeacemaker": "Απαντήστε σε κάθε Ναι ή Όχι, ξεκινώντας από ειρηνοποιό.",
    "hintHomebuilder": "Απαντήστε αν είστε οικοδόμος σπιτιού.",
    "hintHumorous": "Απαντήστε αν έχετε χιούμορ.",
    "hintCaring": "Απαντήστε αν είστε φροντιστικοί και τρυφεροί.",
    "hintPeaceful": "Απαντήστε αν θέλετε ειρηνικό σπίτι.",
    "hintManners": "Απαντήστε αν έχετε καλούς τρόπους.",
    "hintHonesty": "Σύρετε τη βαθμολογία ειλικρίνειας από 1 έως 10."
  },
  "history": {
    "eyebrow": "Matching · Ιστορικό",
    "title": "Παρελθόν και ετοιμότητα",
    "text": "Ουσίες, παιδική ηλικία, ουλές και αν είστε έτοιμοι για διαρκή σχέση. Η αλήθεια εδώ προστατεύει και τους δύο.",
    "marijuana": "Έχετε χρησιμοποιήσει μαριχουάνα;",
    "lsd": "Έχετε χρησιμοποιήσει LSD;",
    "otherDrugs": "Έχετε χρησιμοποιήσει άλλα ναρκωτικά;",
    "addicted": "Έχετε υπάρξει εθισμένοι;",
    "childhood": "Σταθερή, γεμάτη αγάπη παιδική ηλικία;",
    "scars": "Ουλές / πληγωμένοι;",
    "lasting": "Έτοιμοι για διαρκή σχέση;",
    "hintStart": "Απαντήστε σε κάθε Ναι ή Όχι σε αυτή τη σελίδα, ξεκινώντας από πάνω.",
    "hintLsd": "Απαντήστε στην ερώτηση LSD — Ναι ή Όχι.",
    "hintOtherDrugs": "Απαντήστε αν έχετε χρησιμοποιήσει άλλα ναρκωτικά.",
    "hintAddicted": "Απαντήστε αν έχετε υπάρξει εθισμένοι.",
    "hintChildhood": "Απαντήστε αν η παιδική σας ηλικία ήταν σταθερή και γεμάτη αγάπη.",
    "hintScars": "Απαντήστε αν φέρετε ουλές.",
    "hintLasting": "Απαντήστε αν είστε έτοιμοι για διαρκή σχέση."
  },
  "appearance": {
    "eyebrow": "Matching · Εμφάνιση",
    "title": "Τατουάζ",
    "text": "Τα τατουάζ σας και αν τα τατουάζ σε σύντροφο είναι αποδεκτά για εσάς.",
    "hasTattoos": "Έχετε τατουάζ;",
    "acceptsPartner": "Αποδέχεστε τατουάζ σε σύντροφο;",
    "hintHas": "Πείτε αν έχετε τατουάζ — Ναι ή Όχι.",
    "hintAccepts": "Πείτε αν τα τατουάζ σε σύντροφο είναι αποδεκτά για εσάς."
  },
  "home": {
    "eyebrow": "Matching · Σπίτι & γη",
    "title": "Γη, δεξιότητες, αυτάρκεια",
    "text": "Βότανα, καλλιέργεια τροφής, δάσος φρούτων, προετοιμασία, κοινοτική γεωργία, συντήρηση, επιβίωση — και ειδικές δεξιότητες.",
    "herbKnowledge": "Γνώση βοτάνων;",
    "plantOwn": "Φυτεύετε τα δικά σας φρούτα και λαχανικά;",
    "fruitForest": "Ενδιαφέρον για δάσος φρούτων;",
    "prepping": "Προετοιμασία για καταστροφές;",
    "communityFarming": "Κοινοτική γεωργία / ανεξάρτητη ζωή;",
    "canning": "Κονσερβοποίηση και συντήρηση;",
    "survival": "Δεξιότητες επιβίωσης;",
    "specialSkills": "Ειδικές δεξιότητες (προαιρετικό)",
    "specialPlaceholder": "Οτιδήποτε άλλο φέρνετε σε νοικοκυριό ή γη…",
    "hintStart": "Απαντήστε σε κάθε Ναι ή Όχι για γη και δεξιότητες, ξεκινώντας από πάνω.",
    "hintPlant": "Απαντήστε αν φυτεύετε τα δικά σας φρούτα και λαχανικά.",
    "hintFruitForest": "Απαντήστε αν σας ενδιαφέρει δάσος φρούτων.",
    "hintPrepping": "Απαντήστε αν προετοιμάζεστε για καταστροφές.",
    "hintCommunity": "Απαντήστε αν σας ενδιαφέρει κοινοτική γεωργία.",
    "hintCanning": "Απαντήστε αν κονσερβοποιείτε και συντηρείτε τρόφιμα.",
    "hintSurvival": "Απαντήστε αν έχετε δεξιότητες επιβίωσης."
  },
  "family": {
    "eyebrow": "Matching · Οικογένεια",
    "title": "Παιδιά, βάθος πίστης, ουσίες",
    "text": "Τι χρειάζεστε σε σύντροφο ως προς ένταση πίστης, παιδιά και παρελθόν χρήση ουσιών.",
    "children": "Παιδιά",
    "wants": {
      "label": "Θέλει παιδιά",
      "hint": "Η οικογένεια είναι μέρος του οράματος."
    },
    "doesNotWant": {
      "label": "Δεν θέλει παιδιά",
      "hint": "Καθαρό όχι στα παιδιά."
    },
    "open": {
      "label": "Ανοιχτός/ή",
      "hint": "Διακρίνει — όχι κλειδωμένος/η ούτε προς τη μία ούτε προς την άλλη."
    },
    "hasLivingWith": {
      "label": "Έχει παιδιά — ζει μαζί τους",
      "hint": "Τα παιδιά είναι ήδη μέρος της καθημερινότητας."
    },
    "requiredFaith": "Ελάχιστο επίπεδο πίστης που χρειάζεστε σε σύντροφο",
    "requiredFaithHint": "10% … 100%. Σκληρή πύλη όταν έχουν απαντήσει και οι δύο πλευρές.",
    "acceptsSubstances": "Αποδέχεστε παρελθόν χρήση ουσιών σε σύντροφο;",
    "hintChildren": "Επιλέξτε μία κάρτα για τα παιδιά.",
    "hintFaith": "Σύρετε το ελάχιστο επίπεδο πίστης που ελπίζετε σε σύντροφο.",
    "hintSubstances": "Πείτε αν η παρελθόν χρήση ουσιών σε σύντροφο είναι αποδεκτή."
  },
  "ancestry": {
    "eyebrow": "Matching · Υπόβαθρο",
    "title": "Προτιμήσεις υπόβαθρου",
    "text": "Μοιραστείτε το υπόβαθρό σας και σε τι είστε ανοιχτοί σε σύντροφο. Αυτό διαμορφώνει μόνο την κατάταξη — ποτέ δεν κρύβει κάποιον από το deck.",
    "yourBackground": "Το υπόβαθρό σας (επιλέξτε όλα όσα ισχύουν)",
    "openToPartner": "Ανοιχτός/ή σε σύντροφο",
    "codeDesc": "Κωδικός: {code}",
    "anyDesc": "Ισχυρότερη προτίμηση για εύρος — συνιστάται όταν δεν είστε σίγουροι.",
    "preferenceOnly": "Μόνο προτίμηση — όχι πύλη.",
    "hintOwn": "Τσεκάρετε τουλάχιστον ένα υπόβαθρο που σας περιγράφει. Βοηθά μόνο την κατάταξη — ποτέ δεν κρύβει κανέναν.",
    "hintAccepted": "Τσεκάρετε σε τι είστε ανοιχτοί σε σύντροφο, ή «Ανοιχτός/ή — χωρίς προτίμηση»."
  },
  "interests": {
    "eyebrow": "Matching · Ενδιαφέροντα",
    "title": "Τι σας αρέσει",
    "text": "Επιλέξτε τουλάχιστον ένα. Η επικάλυψη βοηθά την κατάταξη· η σιωπή δεν τιμωρείται ποτέ.",
    "hint": "Τσεκάρετε τουλάχιστον ένα ενδιαφέρον."
  },
  "reflection": {
    "eyebrow": "Matching · Αναστοχασμός",
    "title": "Με δικά σας λόγια",
    "text": "Αυτές οι τέσσερις απαντήσεις εμφανίζονται ολόκληρες και δεν βαθμολογούνται ποτέ. Γράψτε ό,τι είναι αληθινό.",
    "describeYourself": "Περιγράψτε τον εαυτό σας",
    "lifePurpose": "Σκοπός ζωής",
    "fifteenYear": "Εσείς και ο έρωτας της ζωής σας σε 15 χρόνια",
    "weaknesses": "Αδυναμίες",
    "hintDescribe": "Περιγράψτε τον εαυτό σας σε τουλάχιστον {min} χαρακτήρες.",
    "hintPurpose": "Γράψτε τον σκοπό ζωής σας σε τουλάχιστον {min} χαρακτήρες.",
    "hintVision": "Γράψτε το όραμα 15 ετών σε τουλάχιστον {min} χαρακτήρες.",
    "hintWeaknesses": "Ονομάστε μια αδυναμία σε τουλάχιστον {min} χαρακτήρες."
  },
  "profile": {
    "eyebrow": "Προφίλ",
    "title": "Μερικά βασικά",
    "text": "Κρατήστε το απλό. Το φύλο εδώ είναι δυαδικό — άνδρας ή γυναίκα — για καθαρό matching.",
    "firstName": "Όνομα",
    "firstNamePlaceholder": "Όπως θέλετε να σας γνωρίζουν",
    "age": "Ηλικία",
    "agePlaceholder": "18+",
    "city": "Πόλη",
    "cityPlaceholder": "Πού βασίζεστε",
    "sex": "Φύλο",
    "maleBody": "Είμαι άνδρας.",
    "femaleBody": "Είμαι γυναίκα.",
    "hintName": "Πληκτρολογήστε το όνομά σας (τουλάχιστον δύο γράμματα).",
    "hintAge": "Η ηλικία πρέπει να είναι 18 ή μεγαλύτερη.",
    "hintCity": "Πληκτρολογήστε την πόλη όπου ζείτε.",
    "hintGender": "Επιλέξτε Άνδρας ή Γυναίκα ώστε να λειτουργεί το matching."
  },
  "ready": {
    "title": "Μπορείτε να εισέλθετε.",
    "textNamed": "{name}, η επαλήθευση και η ρύθμισή σας καταγράφηκαν. Τα μέσα είναι pending_review. Καλώς ήρθατε στο UN8 — βρείτε τον άνθρωπό σας, μετά διαγράψτε την εφαρμογή.",
    "text": "Η επαλήθευση και η ρύθμισή σας καταγράφηκαν. Τα μέσα είναι pending_review. Καλώς ήρθατε στο UN8 — βρείτε τον άνθρωπό σας, μετά διαγράψτε την εφαρμογή.",
    "summaryAria": "Σύνοψη ρύθμισης",
    "christianRules": "Χριστιανός/ή · κανόνες επιβεβαιωμένοι",
    "mediaLine": "Ταυτότητα · βίντεο · {photoCount} φωτογραφίες · ουρά {pending}",
    "scalesLine": "Κλίμακες L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Φύλο —",
    "professionFallback": "επάγγελμα",
    "userLine": "Χρήστης {userId}",
    "enterMatching": "Είσοδος στο matching",
    "needGender": "Επιστρέψτε στο βήμα προφίλ και επιλέξτε Άνδρας ή Γυναίκα, μετά δοκιμάστε ξανά."
  },
  "match": {
    "brandTag": "Matching",
    "navOnboarding": "Onboarding",
    "navReview": "Έλεγχος",
    "navMatching": "Matching",
    "logOut": "Αποσύνδεση",
    "enterTitle": "Είσοδος στο matching",
    "enterText": "Συνδεθείτε με το ίδιο email από το onboarding. Αίτηση, pool, likes και matches χρησιμοποιούν όλα το σταθερό user id σας.",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "password": "Κωδικός",
    "passwordPlaceholder": "Ο κωδικός σας",
    "logIn": "Σύνδεση",
    "guestOr": "Ή δοκιμάστε guest session (σταθερό id ανά πρόγραμμα περιήγησης · μόνο demo)",
    "guestMan": "Guest ως άνδρας",
    "guestWoman": "Guest ως γυναίκα",
    "goOnboarding": "Μετάβαση στο onboarding →",
    "guestSession": "Συνεδρία επισκέπτη · demo pool",
    "packTitle": "Οι τέσσερις σου",
    "packSkip": "Πατήστε για συνέχεια",
    "newSelection": "Νέα επιλογή",
    "backToFour": "← Πίσω στους τέσσερις",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "άνδρας",
    "woman": "γυναίκα",
    "navSelection": "Επιλογή",
    "navMessages": "Μηνύματα",
    "navProfile": "Προφίλ",
    "tabToday": "Επιλογή",
    "tabMatches": "Matches ({count})",
    "yourMatches": "Τα matches σας",
    "matchesSub": "Διαρκές αμοιβαίο ενδιαφέρον · {count} εξερχόμενα {likesWord}",
    "like": "like",
    "likes": "likes",
    "emptyMatches": "Δεν υπάρχει ακόμη αμοιβαίο ενδιαφέρον. Συνέχισε να διακρίνεις ξεχωριστά την επιλογή αυτής της εβδομάδας.",
    "valuesScore": "Αξίες {score}",
    "chatOpen": " · Chat ανοιχτό",
    "tapToChat": " · Πατήστε για chat",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Αξίες {score}",
    "noProfileYet": "Δεν υπάρχει ακόμα προφίλ",
    "noProfileText": "Ολοκληρώστε το onboarding ή πατήστε Onboarding επάνω, μετά Έναρξη. Το guest matching είναι στην οθόνη εισόδου αν θέλετε μόνο να δείτε.",
    "matchingPaused": "Το matching σε παύση",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Κανείς για εμφάνιση ακόμα",
    "todaysSetDone": "Αυτή είναι η επιλογή αυτής της εβδομάδας",
    "weeklyTitle": "Οι 4 σου αυτή την εβδομάδα",
    "weeklyTitleCount": "Οι {count} σου αυτή την εβδομάδα",
    "weeklyCountdown": "Επόμενη επιλογή σε {days} ημέρες",
    "weeklyCountdownOne": "Επόμενη επιλογή σε 1 ημέρα",
    "weeklyCountdownSoon": "Επόμενη επιλογή σύντομα",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Αυτή είναι η επιλογή αυτής της εβδομάδας",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Δεν υπάρχει ακόμη κανείς στη λίστα αυτής της εβδομάδας. Η ομάδα γεμίζει — άνοιξε ξανά την Επιλογή σε λίγο, ή έλα πίσω όταν εγκριθούν περισσότερα μέλη.",
    "emptyDone": "Έχεις δει την επιλογή αυτής της εβδομάδας. Έλα πίσω στο επόμενο άνοιγμα, ή επαναφορά της τράπουλας.",
    "likesMayNotStick": " Τα likes μπορεί να μην παραμείνουν.",
    "poolMeta": "Pool: {pool} · Matches: {matches} · Ενδιαφέρον: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Επαναφορά deck",
    "backOnboarding": "Πίσω στο onboarding",
    "feedEyebrowDemo": "Εβδομαδιαία επιλογή · Demo",
    "feedEyebrowLive": "Εβδομαδιαία επιλογή · Pool ({source}, {count})",
    "feedTitle": "Διακρίνετε με προσοχή",
    "left": "απομένουν {count}",
    "pass": "Πάσο",
    "interested": "Ενδιαφέρον",
    "swipeHint": "Κάντε swipe ή χρησιμοποιήστε τα κουμπιά. Ένα match ανοίγει μόνο όταν το ενδιαφέρον είναι αμοιβαίο και αποθηκευμένο.",
    "celebrationEyebrow": "Αμοιβαίο ενδιαφέρον",
    "celebrationTitle": "Κάνατε match",
    "celebrationText": "Οι {self} και {other} έδειξαν και οι δύο ενδιαφέρον. Ευθυγράμμιση αξιών: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Το chat ξεκλειδώθηκε για αυτό το match. Κρατήστε το σεβαστικό — διαθήκη πάνω από άνεση.",
    "openChat": "Άνοιγμα chat",
    "keepDiscerning": "Συνέχεια διάκρισης",
    "cardSeeking": "Αναζητά",
    "cardHobbies": "Χόμπι",
    "affinity": "Συγγένεια",
    "valuesScoreLabel": "Βαθμολογία αξιών",
    "scoreStrong": "Ισχυρή ευθυγράμμιση",
    "scoreSolid": "Σταθερή ευθυγράμμιση",
    "scoreModerate": "Μέτρια ευθυγράμμιση",
    "scoreDifferent": "Διαφορετικοί ρυθμοί",
    "characterAxisFoot": "Ο άξονας χαρακτήρα περιλαμβάνει τους τέσσερις πυλώνες",
    "youThem": "Εσείς {self} · Αυτοί {other}",
    "stampInterest": "Ενδιαφέρον",
    "stampPass": "Πάσο",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Οι βαθμολογίες αξιών σας είναι κοντά ({score} από 100).",
    "explainLegacyFuller": "Ένα πληρέστερο «γιατί» εμφανίζεται αφού και οι δύο ολοκληρώσετε τις ερωτήσεις matching.",
    "explainFaith": "Η ένταση πίστης σας είναι κοντά — παίρνετε την ακολουθία του Ιησού με παρόμοια σοβαρότητα.",
    "explainCharacter": "Πώς συμπεριφέρεστε στους ανθρώπους στο σπίτι ευθυγραμμίζεται — ειρήνη, τρόποι και φροντίδα.",
    "explainPurpose": "Αξιολογήσατε την ειλικρίνειά σας παρόμοια, που είναι σημάδι κοινής σοβαρότητας.",
    "explainHome": "Μοιράζεστε ενδιαφέρον για γη, καλλιέργεια τροφής ή αυτάρκες σπίτι.",
    "explainAncestry": "Και οι δύο προτιμάτε παρόμοια οικογενειακά υπόβαθρα. Είναι προτίμηση, όχι φίλτρο — κανείς δεν κρύβεται γι’ αυτό.",
    "explainTemperament": "Τα ενδιαφέροντα και η ιδιοσυγκρασία σας επικαλύπτονται.",
    "explainFallback": "Υπάρχει πιθανό match στις απαντήσεις που συμπληρώσατε και οι δύο.",
    "explainOverall": "Συνολική συγγένεια {score} από 100.",
    "affinityAxes": {
      "faith": "Ένταση πίστης",
      "character": "Χαρακτήρας & συμπεριφορά",
      "purpose": "Ευθυγράμμιση σκοπού ζωής",
      "home": "Σπίτι & αυτάρκεια",
      "ancestry": "Πολιτισμική & υπόβαθρου συγγένεια",
      "temperament": "Ταίριασμα ιδιοσυγκρασίας"
    },
    "scaleAxes": {
      "loyalty": "Αφοσίωση",
      "honesty": "Ειλικρίνεια",
      "passion": "Πάθος",
      "commitment": "Δέσμευση"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Το chat δεν είναι διαθέσιμο",
    "unavailableText": "Αυτό το match λείπει ή δεν ανήκει στη συνεδρία σας.",
    "backToMatches": "Πίσω στα matches",
    "backMatches": "← Matches",
    "valuesSubscriber": "Αξίες {score} · Συνδρομητής",
    "valuesTrial": "Αξίες {score} · Δοκιμή",
    "valuesKept": "Αξίες {score} · Match διατηρήθηκε",
    "empty": "Πείτε γεια με φροντίδα. Στο κοινό backend, τα μηνύματα συγχρονίζονται και στα δύο τηλέφωνα μετά από αμοιβαίο match.",
    "placeholder": "Μήνυμα στον/στην {name}…",
    "ariaMessage": "Μήνυμα",
    "send": "Αποστολή"
  },
  "billing": {
    "paywallCopy": "Μετά τη δωρεάν δοκιμή, κρατήστε όλους με τους οποίους έχετε ήδη κάνει match και συνεχίστε το chat. Για να δείτε νέους ανθρώπους, εγγραφείτε.",
    "signInToMatch": "Συνδεθείτε για να χρησιμοποιήσετε το matching.",
    "signInFirst": "Συνδεθείτε πρώτα.",
    "subscriberUntil": "Συνδρομητής · έως {date}",
    "renewal": "ανανέωση",
    "freeTrial": "Δωρεάν δοκιμή · {days} ημέρες (λήγει {date})",
    "soon": "σύντομα",
    "trialEnded": "Η δοκιμή έληξε · matches & chat παραμένουν ανοιχτά",
    "subscribe": "Εγγραφή · ${price}/μήνα",
    "subscribeEarly": "Εγγραφή νωρίς · ${price}/μήνα",
    "activeNote": "Η συνδρομή είναι ενεργή — μπορείτε να δείτε ξανά νέους ανθρώπους.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Αποθηκεύστε τον κωδικό ανάκτησης",
    "recoveryText": "Γράψτε το τώρα. Εμφανίζεται μία φορά. Αν χάσετε το passphrase, αυτός ο κωδικός είναι ο μόνος τρόπος επαναφοράς στο κλειστό τεστ.",
    "savedContinue": "Το αποθήκευσα — συνέχεια",
    "welcomeBack": "Καλώς ήρθατε ξανά",
    "createAccount": "Δημιουργήστε τον λογαριασμό σας",
    "intro": "Handle και passphrase. Δεν αποστέλλεται email ή SMS. Το id σας μένει σταθερό σε onboarding, έλεγχο και matching.",
    "tabLogin": "Σύνδεση",
    "tabRegister": "Εγγραφή",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com ή σύντομο handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Τουλάχιστον 8 χαρακτήρες",
    "submitLogin": "Σύνδεση",
    "submitRegister": "Δημιουργία λογαριασμού",
    "backWelcome": "Πίσω στην υποδοχή"
  },
  "options": {
    "origin": {
      "african": "Αφρικανικό",
      "european": "Ευρωπαϊκό",
      "asian": "Ασιατικό",
      "latino": "Latino / Hispanic",
      "middleEastern": "Μέσης Ανατολής",
      "indigenous": "Αυτόχθονο",
      "mixed": "Μικτό",
      "other": "Άλλο",
      "dutch": "Ολλανδικό",
      "german": "Γερμανικό",
      "any": "Ανοιχτός/ή — χωρίς προτίμηση"
    },
    "interest": {
      "prayer": "Προσευχή",
      "worship": "Λατρεία",
      "reading": "Διάβασμα",
      "hiking": "Πεζοπορία",
      "music": "Μουσική",
      "cooking": "Μαγειρική",
      "farming": "Γεωργία / κηπουρική",
      "sports": "Αθλήματα",
      "missions": "Ιεραποστολές",
      "family": "Οικογενειακή ζωή",
      "crafts": "Χειροτεχνίες",
      "outdoors": "Ύπαιθρος"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ναι",
      "no": "Όχι"
    },
    "id": {
      "titleEmpty": "Κυβερνητική ταυτότητα",
      "titleReady": "Η ταυτότητα είναι έτοιμη",
      "hintEmpty": "Διαβατήριο ή εθνική ταυτότητα. Τραβήξτε live φωτογραφία ή επιλέξτε εικόνα/PDF. Και οι τέσσερις γωνίες ορατές.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · αποθηκευμένο",
      "previewAlt": "Προεπισκόπηση κυβερνητικής ταυτότητας",
      "pdfAria": "Επιλέχθηκε έγγραφο PDF",
      "takePhoto": "Λήψη φωτογραφίας",
      "retake": "Επανάληψη",
      "chooseFile": "Επιλογή αρχείου",
      "replaceFile": "Αντικατάσταση αρχείου",
      "remove": "Αφαίρεση",
      "uploading": "Ανέβασμα…",
      "cameraTitle": "Φωτογραφίστε την ταυτότητά σας",
      "signIn": "Συνδεθείτε πριν ανεβάσετε ταυτότητα.",
      "uploadFailed": "Το ανέβασμα απέτυχε. Δοκιμάστε ξανά.",
      "badFile": "Δεν ήταν δυνατή η χρήση αυτού του αρχείου."
    },
    "video": {
      "titleEmpty": "Βίντεο επιβεβαίωσης",
      "titleLive": "Κάμερα ζωντανή",
      "titleReady": "Το βίντεο είναι έτοιμο",
      "hintEmpty": "Πείτε το όνομά σας και ότι μπαίνετε στο UN8 ειλικρινά. 5–15 δευτερόλεπτα.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Εγγραφή",
      "cameraUpload": "Ανέβασμα κάμερας",
      "chooseFile": "Επιλογή αρχείου",
      "startRecording": "Έναρξη εγγραφής",
      "cancel": "Ακύρωση",
      "stopSave": "Διακοπή & αποθήκευση",
      "recordAgain": "Εγγραφή ξανά",
      "replaceFile": "Αντικατάσταση αρχείου",
      "remove": "Αφαίρεση",
      "unsupported": "Η ζωντανή εγγραφή δεν είναι διαθέσιμη εδώ. Χρησιμοποιήστε ανέβασμα κάμερας ή επιλέξτε αρχείο.",
      "permissionDenied": "Η άδεια κάμερας απορρίφθηκε. Μπορείτε ακόμα να ανεβάσετε σύντομο αρχείο βίντεο.",
      "signIn": "Συνδεθείτε πριν ανεβάσετε βίντεο.",
      "uploadFailed": "Το ανέβασμα απέτυχε. Δοκιμάστε ξανά.",
      "saveFailed": "Δεν ήταν δυνατή η αποθήκευση της εγγραφής.",
      "badVideo": "Δεν ήταν δυνατή η χρήση αυτού του βίντεο."
    },
    "photos": {
      "count": "{count} / {max} φωτογραφίες",
      "minimumMet": "Ελάχιστο επιτεύχθηκε",
      "moreRequired": "Απαιτούνται {n} ακόμη",
      "listAria": "Φωτογραφίες επαλήθευσης",
      "photoAlt": "Φωτογραφία {n}",
      "removeAria": "Αφαίρεση φωτογραφίας {n}",
      "camera": "Κάμερα",
      "takePhoto": "Λήψη φωτογραφίας",
      "chooseFiles": "Επιλογή αρχείων",
      "uploading": "Ανέβασμα…",
      "hint": "Η Λήψη φωτογραφίας ανοίγει τη ζωντανή κάμερα. Η Επιλογή αρχείων είναι μόνο για γκαλερί. Καθαρές λήψεις προσώπου — χωρίς φίλτρα που κρύβουν την ταυτότητα. Max {max}.",
      "cameraTitle": "Τραβήξτε φωτογραφία του εαυτού σας",
      "signIn": "Συνδεθείτε πριν ανεβάσετε φωτογραφίες.",
      "someFailed": "Ορισμένες φωτογραφίες απέτυχαν να ανεβούν. Επαναλάβετε τις αποτυχημένες.",
      "addFailed": "Δεν ήταν δυνατή η προσθήκη φωτογραφιών."
    },
    "liveStill": {
      "titleDefault": "Κάμερα",
      "close": "Κλείσιμο",
      "capture": "Λήψη",
      "cancel": "Ακύρωση",
      "hint": "Κρατήστε σταθερά. Η ζωντανή κάμερα μένει ανοιχτή μέχρι να τραβήξετε.",
      "unavailable": "Η κάμερα δεν είναι διαθέσιμη σε αυτό το πρόγραμμα περιήγησης. Χρησιμοποιήστε Επιλογή αρχείου.",
      "permissionDenied": "Η άδεια κάμερας απορρίφθηκε ή δεν είναι διαθέσιμη. Χρησιμοποιήστε Επιλογή αρχείου.",
      "frameFailed": "Δεν ήταν δυνατή η λήψη αυτού του καρέ.",
      "saveFailed": "Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας."
    },
    "uploadStatus": {
      "uploading": "ανέβασμα…",
      "failed": "το ανέβασμα απέτυχε",
      "savedLocally": "αποθηκευμένο τοπικά",
      "uploaded": "ανέβηκε",
      "stored": "αποθηκεύτηκε",
      "awaitingUpload": "Αναμονή ανεβάσματος",
      "localFallbackNote": "{error} Το αρχείο αποθηκεύτηκε σε αυτή τη συσκευή· δοκιμάστε ξανά όταν το sign endpoint είναι διαθέσιμο."
    }
  },
  "language": {
    "label": "Γλώσσα",
    "choose": "Επιλογή γλώσσας"
  },
  "shell": {
    "back": "Πίσω",
    "goBackAria": "Πίσω"
  }
} as Messages;
